import React, { useEffect, useState } from 'react';
import CircuitBenchmarkForm from './CircuitBenchmarkForm';
import RecentCircuitBenchmarks from './RecentCircuitBenchmarks';
import { supabase } from '../supabaseClient';


const CircuitBenchmark = ({ circuit_id, circuitFiles, onError, disabled }) => {

    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchCircuitJobs = async () => {
        try {
            setLoading(true);
            const { data: circuitJobs, error: fetchError } = await supabase
                .from("jobs")
                .select("id,status,created_at,updated_at,configuration, snapshot:snapshots!inner (id,hash, circuit_id)")
                .eq("snapshots.circuit_id", circuit_id)
                .order("updated_at", { ascending: false })
                .limit(3);

            if (fetchError) throw fetchError;

            setJobs(circuitJobs);
            setLoading(false);
        } catch (err) {
            let returned_error = await err.context.json();
            onError(`Failed to load circuit jobs - ${returned_error.error}`);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCircuitJobs();
    }, [circuit_id])

    const handleNewJob = async (jobData) => {
        try {
            const { data, error } = await supabase.functions.invoke('submit-benchmark', {
                body: {
                    circuit_id: circuit_id,
                    configuration: jobData
                },
            })

            if (error) throw error;
            setJobs((prev) => [...data.job, ...prev]);
            return true;
        } catch (err) {
            let returned_error = await err.context.json();
            onError(`Failed to submit new benchmark request - ${returned_error.error}`);
            return true;
        }
    };

    return (
        <div className="column is-one-quarter" style={{ borderLeft: '1px solid #e5e7eb' }}>
            <CircuitBenchmarkForm
                circuit_id={circuit_id}
                circuitFiles={circuitFiles}
                onError={onError}
                onSubmit={handleNewJob}
                disabled={disabled}
            />
            {/* <hr /> */}


            <div>
                <h2 className="subtitle is-5">Recent Submissions</h2>
                {loading ? (
                    <p className="has-text-grey">Loading benchmarks…</p>
                ) : jobs.length === 0 ? (
                    <div className="notification is-light">
                        <p>No benchmarks found for this circuit.</p>
                        <p className="is-size-7 has-text-grey">
                            Submit a new benchmark to see it here.
                        </p>
                    </div>
                ) : (
                    <RecentCircuitBenchmarks jobs={jobs.slice(0,3)} setJobs={setJobs} />
                )}
            </div>
        </div>
    );
}

export default CircuitBenchmark;